import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicRoute from "./components/PublicRoute";
import Home from "./pages/Home";
import SeatSelection from "./pages/SeatSelection";
import CreateAccount from "./pages/CreateAccount";
import Login from "./pages/Login";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import OffersComponent from "./pages/Offers";
import ShowsList from "./components/ShowsList";
import MovieListingPage from "./pages/MovieListingPage";
import Profile from "./pages/Profile";
import ScrollToTop from "./components/ScrollToTop";
import MovieDetails from "./pages/MovieDetails";
import ViewBlog from "./pages/ViewBlog";
import Blog from "./pages/Blog";
import MyBooking from "./pages/MyBooking";
import About from "./pages/About";
import Contact from "./pages/Contact";
import TermsAndConditions from "./pages/TermsAndConditions";
import FAQs from "./pages/FAQs";
import AuthPage from "./pages/AuthPage";
import ForgotAndResetPassword from "./pages/AuthPage";
import GrandCinemazTeam from "./pages/GrandCinemazTeam";

import Food from "./pages/Food";

const Layout = () => (
  <Router>
    <ScrollToTop />
    <Navbar />
    <div className="pt-20">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/book-seats/:showId" element={<SeatSelection />} />

        {/* Public Routes */}
        <Route
          path="/register"
          element={
            <PublicRoute>
              <CreateAccount />
            </PublicRoute>
          }
        />
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />

        {/* Public pages */}
        <Route path="/offers" element={<OffersComponent />} />
        <Route path="/shows" element={<ShowsList />} />
        <Route path="/food" element={<Food />} />

        <Route path="/forgot-password" element={<ForgotAndResetPassword />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/view-blog/:id" element={<ViewBlog />} />
        <Route path="/movies" element={<MovieListingPage />} />
        <Route path="/moviedetails/:id" element={<MovieDetails />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/team" element={<GrandCinemazTeam />} />
        <Route path="/termsandconditions" element={<TermsAndConditions />} />
        <Route path="/faqs" element={<FAQs />} />

        {/* Protected Routes */}
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/bookings"
          element={
            <ProtectedRoute>
              <MyBooking />
            </ProtectedRoute>
          }
        />
      </Routes>
    </div>
    <Footer />
  </Router>
);

export default Layout;
